import { createReducer } from '@reduxjs/toolkit';
import omit from 'lodash/omit';

import { ActionFailureType, ActionSuccessType, GET_ROOT_SITE, UPDATE_SITE_THEME } from 'constants/redux-actions';

const initState = {
  childrenSites: [],
  loading: true,
};

const rootSiteReducer = createReducer(initState, {
  [GET_ROOT_SITE]: (state) => ({ ...state, loading: true }),
  [ActionSuccessType(GET_ROOT_SITE)]: (_, action) => {
    const { children: childrenSites, id: siteId } = action.payload.data;

    return {
      ...omit(action.payload.data, ['children', 'id']),
      childrenSites,
      siteId,
      loading: false,
    };
  },
  [ActionFailureType(GET_ROOT_SITE)]: (state) => ({ ...state, loading: false }),
  [UPDATE_SITE_THEME]: (state, action) => ({ ...state, ...action.payload }),
});

export default rootSiteReducer;
